document.addEventListener('DOMContentLoaded', function () {
    const ctaBtns = document.querySelectorAll('.cta-share');
    const className = 'copied'; // Change this to your preferred class

    ctaBtns.forEach(function (ctaBtn) {
        ctaBtn.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default anchor behavior

            // Copy current page URL to clipboard
            navigator.clipboard.writeText(window.location.href).then(function () {
                // Add class
                ctaBtn.classList.add(className);

                // Remove class after 5 seconds
                setTimeout(function () {
                    ctaBtn.classList.remove(className);
                }, 5000);
            }).catch(function (err) {
                console.error('Failed to copy URL:', err);
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const menuLinks = document.querySelectorAll('.scroll-to');

    menuLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                // Choose offset based on screen width
                const isMobile = window.innerWidth < 768;
                const offset = isMobile ? 64 : 82; // Customize these values as needed

                // Get element position
                const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;

                // Scroll to position with offset
                window.scrollTo({
                    top: elementTop - offset,
                    behavior: 'smooth'
                });
            }

            if(targetId == '#transportation-calculator') {
                document.querySelector('.tab-button[data-tab="transport"]').click();
            }
        });
    });
});

function observeSection(element, className, options = {}) {
  // Default options
  const defaults = {
    startPoint: 0.2, // 0 to 1, where 0.2 means 20% of element visible
    rootMargin: '0px',
    once: false // Set to true if you want to observe only once
  };
  
  const settings = { ...defaults, ...options };
  
  // Create the Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add class when section is in view
        entry.target.classList.add(className);
        
        // Optionally unobserve after first intersection
        if (settings.once) {
          observer.unobserve(entry.target);
        }
      } else {
        // Remove class when section leaves view (unless 'once' is true)
        if (!settings.once) {
          entry.target.classList.remove(className);
        }
      }
    });
  }, {
    threshold: settings.startPoint,
    rootMargin: settings.rootMargin
  });
  
  // Start observing
  if (element) {
    observer.observe(element);
  }
  
  // Return the observer in case you need to disconnect it later
  return observer;
}

// Custom start point - triggers when 50% is visible
const section2 = document.querySelector('.fw-image');
observeSection(section2, 'active', { startPoint: 0.3, once: true });



/* tabs */
function initTabs() {
    const container = document.getElementById('tabContainer');
    const background = document.getElementById('tabBackground');
    const buttons = container.querySelectorAll('.tab-button');
    
    function updateBackground(btn) {
        const rect = btn.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        background.style.width = rect.width + 'px';
        background.style.height = rect.height + 'px';
        background.style.left = (rect.left - containerRect.left) + 'px';
        background.style.top = 0;//(rect.top - containerRect.top) + 'px';
    }
    
    // Initialize background position
    const activeBtn = container.querySelector('.tab-button.active');
    updateBackground(activeBtn);
    
    // Handle tab clicks
    buttons.forEach(btn => {
        btn.addEventListener('click', function() {
            const tabId = this.dataset.tab;
            
            // Update active states
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            
            // Move background
            updateBackground(this);
            
            // Update content
            document.querySelectorAll('.tab-content').forEach(content => {
                content.classList.remove('active');
            });
            document.getElementById(tabId).classList.add('active');
        });
    });
    
    // Update on window resize
    window.addEventListener('resize', () => {
        const activeBtn = container.querySelector('.tab-button.active');
        updateBackground(activeBtn);
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
} else {
    initTabs();
}

// Re-initialize on window load to fix dimension issues
window.addEventListener('load', () => {
    const container = document.getElementById('tabContainer');
    const activeBtn = container?.querySelector('.tab-button.active');
    if (activeBtn && container) {
        const background = document.getElementById('tabBackground');
        const rect = activeBtn.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        background.style.width = rect.width + 'px';
        background.style.height = rect.height + 'px';
        background.style.left = (rect.left - containerRect.left) + 'px';
        background.style.top = 0;
    }
});